import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Form, Row, Col, Input, Label, FormGroup, Button, Accordion, AccordionBody, AccordionHeader, AccordionItem, TabContent, TabPane, Nav, NavItem, NavLink, Badge, Modal,Popover,PopoverBody,ModalBody,ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import LoadingSpin from "react-loading-spin";
import classnames from 'classnames';

class StudentDirectory extends Component {
    static displayName = StudentDirectory.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            useSemester: [],
            activeSemester: "",
            searchType1: 'FNAME',
            searchString1: "",
            currentFilters: [],
            loading: false,
            studentData: [],
            accordionOpen: '',
            activeTab: '1',
            activeInnerTab: "",
            activeAcadTab: "",
            searchModal: false,
            saveModal:false,
            isContains: "is",
            searchOptions: [],
            searchInputName: "",
            userSearches: [""],
            searchOption: "DEFAULT",
            selectedSearchItems: [],
            loadedSearches: [],
            loadedSearchItemStore: [],
            popOpen: false,
            deleteModalOpen: false,
            searchToDelete: "DEFAULT",
            deleteAskToConfirm: false,
            betweenString: ""
        }
        this.getUserInfo();
        this.testPermission();
        this.getFilterData();
        this.getSavedSearchNames();
    }

    getUserInfo() {
        this.setState({
            returnable: this.props.reduxData.userInfo
        }, () => {
            
        })
    }

    async testPermission() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/StudentDirectory"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.props.updateFetchTime();
        this.setState({
            permissionFlag: data
        })
    }

    async getFilterData() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('StuLookupGetFilter', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }
        })
        const data = await response.json();
        var thisYear = new Date().getFullYear()
        var semesterOptions = []
        var yearList = Array.from(new Array(7), (x, i) => i + (thisYear - 5))
        //console.log("yearList: ",yearList)
        yearList.map(year => {
            semesterOptions.push(`SPRING ${year}`)
            semesterOptions.push(`FALL ${year}`)
        })
        //console.log("semesterOptions: ", semesterOptions)
        this.setState({
            searchOptions: data,
            useSemester: semesterOptions
        })
    }

    async getSavedSearchNames() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('StuLookupGetSavedSearches', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }
        })
        const data = await response.json();
        this.setState({
            userSearches: data
        })
    }

    componentDidMount() {
        //console.log("search options", this.state.searchOptions)
    }

    async getStudents(e) {
        e.preventDefault();
        this.setState({
            loading: true,
            studentData: []
        })
        //console.log("loadedSearchItemStore: ", this.state.loadedSearchItemStore)
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = []
        this.state.currentFilters.map(item => (
            toSend = [...toSend, { type: item.type, operand: item.operand, search: item.string, semester: this.state.activeSemester }]
        ))
        this.state.loadedSearchItemStore.map(item => {
            toSend.push({ type: item.type, operand: item.operand, search: item.string, semester: this.state.activeSemester })
        })
        //console.log("toSend: ", toSend)
        if (this.state.activeSemester != "" && toSend.length != 0) {
            //console.log("toSend:", toSend)
            //console.log("toSend.length ",toSend.length)
            const response = await fetch('StuLookupFilterData', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                studentData: data,
                
            })
        }
        this.setState({
            loading: false
        })
    }

     toggleTab = (id) => {
         if (this.state.activeTab !== id) {
             this.setState({
                 activeTab: id
             });
         }
    }

    removeFilter(type, string) {
        const isTargetFilter = (element) => element.type == type && element.string == string
        let currFilter = this.state.currentFilters
        let indexInt = currFilter.findIndex(isTargetFilter)
        currFilter.splice(indexInt, 1)
        this.setState({
            currentFilters: currFilter
        })
    }

    flipModal() {
        //console.log("list of searches: ", this.state.userSearches)
        this.setState({
            searchModal: !this.state.searchModal
        })
    }

    flipSave() {
        this.setState({
            saveModal: !this.state.saveModal
        })
    }

    flipDeleteModal() {
        this.setState({
            deleteModalOpen: !this.state.deleteModalOpen
        })
    }

    async saveThisSearch() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let sendArray = []
        this.state.currentFilters.map(item => (
            sendArray = [...sendArray, { type: item.type, operand: item.operand, search: item.string, semester: this.state.activeSemester }]
        ))
        this.state.loadedSearchItemStore.map(item => {
            sendArray = [...sendArray, { type: item.type, operand: item.operand, search: item.string, semester: this.state.activeSemester }]
        })
        let toSend = {
            filters: sendArray,
            searchname: this.state.searchInputName
        }
        if (this.state.searchInputName.length > 0) {
            const response = await fetch('StuLookupSaveSearch', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                saveModal: false
            })
            this.getSavedSearchNames()
        }
    }

    async changeSelectedSearch(value) {
        this.setState({
            searchOption: value
        })
        let toSend = {
            pk: value
        }
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('StuLookupGetSearchItems', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            selectedSearchItems: data
        })
    }

    addThisPreSearch() {
        //console.log("selectedSearchItems ")
        //console.log("index:",this.state.loadedSearches.indexOf(this.state.searchOption))
        if (this.state.loadedSearches.indexOf(this.state.searchOption) == -1) {
            let newLoaded = [...this.state.loadedSearches, this.state.userSearches.filter(thisOne => thisOne.pk == this.state.searchOption)[0]]
            //console.log("adding", newLoaded)
            this.setState({
                loadedSearches: newLoaded
            })
            let loadItems = [...this.state.loadedSearchItemStore]
            //console.log("loadItems ", loadItems)
            this.state.selectedSearchItems.map(item => {
                loadItems.push({
                    pk: this.state.searchOption,
                    type: item.type,
                    operand: item.operand,
                    string: item.search
                })
            })
            this.setState({
                loadedSearchItemStore: loadItems
            })
        }
        else {
            //console.log("removing")
            let spliceThisArray = [...this.state.loadedSearches]
            spliceThisArray.splice(spliceThisArray.indexOf(this.state.searchOption), 1)
            this.setState({
                loadedSearches: spliceThisArray
            })
        }
        //let removeSelectedSearch = [...this.state.userSearches]
        //let indexVal = removeSelectedSearch.findIndex(obj => obj.pk == this.state.searchOption)
        //removeSelectedSearch.splice(removeSelectedSearch.indexOf(indexVal))
        //console.log("selectedSearchItems: ", this.state.selectedSearchItems)

        //let newSearchList = [...this.state.loadedSearches]
        //this.state.selectedSearchItems.map(item => {
        //    newSearchList.push({
        //        pk: ,
        //        name:,
        //        type:,
        //        operand:,
        //        string:
        //    })
        //})
        
        this.setState({
            searchOption: "DEFAULT",
            //loadedSearches: removeSelectedSearch,
            searchModal: false,
            selectedSearchItems: []
            //userSearches: this.state.userSearches.filter(remove => remove.pk != this.state.searchOption)
        })
        //console.log("results in: ", this.state.loadedSearches)
    }

    removeSearch(item) {
        //console.log("removing item: ", item)
        //console.log("remove search value: ", this.state.loadedSearches.filter(remove => remove.pk != item))
        this.setState({
            loadedSearches: this.state.loadedSearches.filter(remove => remove.pk != item),
            loadedSearchItemStore: this.state.loadedSearchItemStore.filter(remove => remove.pk != item)
        })
    }

    async sendMail(source) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            students: this.state.studentData,
            emailFlag: source
        }
        alert("We'll sending you an email with this list attached to it")
        const response = await fetch('StudentDirSendStudents', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        
        this.setState({
            popOpen: false
        })
    }

    async deleteSavedSearch() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            pk: this.state.searchToDelete
        }
        this.props.updateFetchTime();
        const response = await fetch('StuDirectoryDeleteSavedSearch', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            userSearches: data
        })
        this.flipDeleteModal()
    }

    openEmail(hrefTarget) {
        this.setState({ popOpen: false })
        let href = hrefTarget;
        let wndw = window.open(href, 'mail');
        const checkLoaded = () => {
            console.log('loaded');
            clearTimeout(t);
            return t = setTimeout(checkClose, 2000);
        };
        let checkClose = () => {
            console.log('checkClose');
            try {
                //wndw.location.href;
                return wndw.close();
            } catch (error) {
                return console.log('webmail');
            }
        };
        let t = setTimeout(checkClose, 5000);
        try {
            
            wndw.onload = checkLoaded;
            let loadEvents = ["DomContentLoaded", "load", "beforeunload", "unload"];
            let results = [];
            for (let i = 0, len = loadEvents.length; i < len; i++) {
                const event = loadEvents[i];
                results.push(wndw.addEventListener(event, checkLoaded));
            }
            return results;
        } catch (error) {
            return checkLoaded();
        }
    }

    accordionDisplay() {
        const toggle = (id) => {
            if (this.state.accordionOpen === id) {
                this.setState({
                    accordionOpen: ''
                })
            }
            else {
                this.setState({
                    accordionOpen: id
                })
            }
        }
        return (<div>
            
            <Accordion open={this.state.accordionOpen} toggle={toggle}>
                {this.state.studentData.map(item => (
                    <AccordionItem>
                        <AccordionHeader targetId={item.pcid}>{item.name} ({item.email})</AccordionHeader>
                        <AccordionBody accordionId={item.pcid}>
                            <ul><li>PCID: {item.pcid}</li>
                                <li>Birthday: {item.birthday}</li>
                                <li>Primary Phone Number: {item.phone}</li>
                                <li>Primary Address: {item.address}</li>
                                {item.veteran != "BLANK" && <li>Veteran Status: {item.veteran}</li>}
                                {item.visa != "BLANK" && <li>Visa Status: {item.visa}</li>}
                            </ul>
                            {item.veteran != "BLANK" && <Nav tabs className="inlineCustom">
                                <NavItem style={{cursor: "pointer" }}>
                                    <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => this.toggleTab('1')}
                                        style={{ color: this.state.activeTab === '1' ? 'green' : 'black' }}
                                        >
                                        Demographics
                                    </NavLink>
                                </NavItem>
                            </Nav>}
                            {item.acadFlag != "0" && <Nav tabs className="inlineCustom">
                                <NavItem style={{ cursor: "pointer" }}>
                                    <NavLink className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => this.toggleTab('2')} style={{ color: this.state.activeTab === '2' ? 'red' : 'black' }}>
                                        Academic
                                    </NavLink>
                                </NavItem>
                            </Nav>}
                            {item.resFlag != "0" && <Nav tabs className="inlineCustom">
                                <NavItem style={{ cursor: "pointer" }}>
                                    <NavLink className={classnames({ active: this.state.activeTab === '3' })}
                                        onClick={() => this.toggleTab('3')} style={{ color: this.state.activeTab === '3' ? 'blue' : 'black' }}>
                                        Residency
                                    </NavLink>
                                </NavItem>
                            </Nav>}
                            {item.veteran != "BLANK" && <TabContent activeTab={item.pcid + this.state.activeTab}>
                                <TabPane tabId={item.pcid + '1'}>
                                        {item.demo.map(demoTab => (
                                            <Nav tabs className="inlineCustom" style={{ cursor: "pointer" }}>
                                                <NavLink className={classnames({ active: this.state.activeInnerTab == demoTab.term + demoTab.year + demoTab.pcid })} onClick={() => this.setState({ activeInnerTab: demoTab.term + demoTab.year + demoTab.pcid })}
                                                    style={{ color: this.state.activeInnerTab == demoTab.term + demoTab.year + demoTab.pcid ? 'green' : 'black'} }
                                                >
                                                {demoTab.term} {demoTab.year}
                                            </NavLink>
                                        </Nav>
                                        ))}
                                        {item.demo.map(demoItem => (
                                            <TabContent activeTab={this.state.activeInnerTab}>
                                                <TabPane tabId={demoItem.term + demoItem.year + demoItem.pcid}>
                                                <div className="halfOfParent">
                                                    <Table bordered hover size="sm" responsive>
                                                        <tbody>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Gender</b></td>
                                                                <td className={"w-75"}>{demoItem.gender}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Veteran Status</b></td>
                                                                <td className={"w-75"}>{demoItem.veteran}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Visa Status</b></td>
                                                                <td className={"w-75"}>{demoItem.visa}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Ethnicity</b></td>
                                                                <td className={"w-75"}>{demoItem.ethnicity}</td>
                                                            </tr>
                                                        </tbody>
                                                        </Table>
                                                    </div>
                                                </TabPane>
                                            </TabContent>
                                        ))}
                                </TabPane>
                            </TabContent>}
                            {item.acadFlag != "0" && <TabContent activeTab={item.pcid + this.state.activeTab}>
                                <TabPane tabId={item.pcid + '2'}>
                                    {[...new Map(item.acad.map(itemIn => [itemIn["year"] + itemIn["term"], itemIn])).values()].map(acadTab => (
                                        <Nav tabs className="inlineCustom" style={{ cursor: "pointer" }}>
                                            <NavLink className={classnames({ active: this.state.activeInnerTab == acadTab.term + acadTab.year + acadTab.pcid })} onClick={() => this.setState({ activeInnerTab: acadTab.term + acadTab.year + acadTab.pcid })}
                                                style={{ color: this.state.activeInnerTab == acadTab.term + acadTab.year + acadTab.pcid ? 'red' : 'black' }}
                                            >
                                                {acadTab.term} {acadTab.year}
                                            </NavLink>
                                        </Nav>
                                    ))}
                                    {item.acad.map(acadItem => (
                                        <TabContent activeTab={this.state.activeInnerTab}>
                                            <TabPane tabId={acadItem.term + acadItem.year + acadItem.pcid}>
                                                <div className="halfOfParent">
                                                    <Table bordered >
                                                        <tbody>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Class Level Code</b></td>
                                                                <td className={"w-75"}>{acadItem.classlevel}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Expected Graduation</b></td>
                                                                <td className={"w-75"}>{acadItem.expectgrad}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={"w-25"} style={{ textAlign: 'right' }}><b>Classes Taken</b></td>
                                                                <td className={"w-75"}><ul>{
                                                                    acadItem.classes.map(event => (
                                                                    <li>{event}</li>
                                                                    ))
                                                                }</ul></td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                {acadItem.semdata.map(semItem => (
                                                    <Nav tabs className="inlineCustom" style={{ cursor: "pointer" }}>
                                                        <NavLink onClick={() => this.setState({ activeAcadTab: semItem.curr + acadItem.pcid })} className={classnames({ active: this.state.activeAcadTab == semItem.curr + acadItem.pcid })}
                                                            style={{color: this.state.activeAcadTab == semItem.curr + acadItem.pcid ? 'red':'black'} }
                                                        >{semItem.curr}</NavLink>
                                                    </Nav>
                                                ))}
                                                {acadItem.semdata.map(semContent => (
                                                    <TabContent activeTab={this.state.activeAcadTab}>
                                                        <TabPane tabId={semContent.curr + acadItem.pcid}>
                                                            <ul>
                                                                <li>Degree: {semContent.deg}</li>
                                                                <li>Enroll/Separation: {semContent.enrollsep}</li>
                                                                <li>Program: {semContent.program}</li>
                                                                <li>Advisor: {semContent.advisor}</li>
                                                            </ul>
                                                        </TabPane>
                                                    </TabContent>
                                                )) }
                                            </TabPane>
                                        </TabContent>
                                    )) }
                                </TabPane>
                            </TabContent>}
                            {item.resFlag != "0" && <TabContent activeTab={item.pcid + this.state.activeTab}>
                                <TabPane tabId={item.pcid + '3'}>
                                    {[...new Map(item.residency.map(itemIn => [itemIn["year"] + itemIn["term"], itemIn])).values()].map(resTab => (
                                        <Nav tabs className="inlineCustom" style={{ cursor: "pointer" }}>
                                            <NavLink className={classnames({ active: this.state.activeInnerTab == resTab.term + resTab.year + resTab.pcid })} onClick={() => this.setState({ activeInnerTab: resTab.term + resTab.year + resTab.pcid })}
                                                style={{ color: this.state.activeInnerTab == resTab.term + resTab.year + resTab.pcid ? 'blue' : 'black' }}
                                            >
                                                {resTab.term} {resTab.year}
                                            </NavLink>
                                        </Nav>
                                    ))}
                                    {item.residency.map(resData => (
                                        <TabContent activeTab={this.state.activeInnerTab }>
                                            <TabPane tabId={resData.term + resData.year + resData.pcid}>
                                                <Table bordered >
                                                    <tbody>
                                                        <tr>
                                                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Resident/Commuter Status</b></td>
                                                            <td className={"w-75"}>{resData.resident}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Food Plan</b></td>
                                                            <td className={"w-75"}>{resData.foodplan}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Dorm Plan</b></td>
                                                            <td className={"w-75"}>{resData.dormplan}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Dorm Room</b></td>
                                                            <td className={"w-75"}>{resData.dormroom}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </TabPane>
                                        </TabContent>
                                    )) }
                                </TabPane>
                            </TabContent>}
                        </AccordionBody>
                    </AccordionItem>
                )) }
            </Accordion>
        </div>)
    }    

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        
            var searchPK = [];
            this.state.loadedSearches.map(item => searchPK.push(item.pk));
        //console.log("searchPK: ", searchPK);
        //if (this.state.studentData.length > 0) {
            let copyString = ""
            this.state.studentData.map(item => {
                copyString = copyString.concat(item.email, ";")
            })
            copyString = copyString.slice(0, -1)
            let userEmail = `mailto:${this.props.reduxData.userInfo.username}@hood.edu?bcc=${copyString}"`
        //}
        //console.log("useSemester", this.state.useSemester)
        return (<div>
            <Modal isOpen={this.state.searchModal} toggle={this.flipModal.bind(this)}>
                <ModalBody>

                    <Input type="select" value={this.state.searchOption} onChange={(e) => this.changeSelectedSearch(e.target.value)}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.userSearches.filter(remove => !searchPK.includes(remove.pk)).map(item => (
                            <option value={item.pk}>{item.name}</option>
                        ))}
                    </Input>
                    <p />
                    {this.state.selectedSearchItems.length > 0 &&
                        <div>{this.state.selectedSearchItems.map(item => (
                            <Badge>{this.state.searchOptions.filter(remove => remove.typecode == item.type)[0].typedesc} {item.operand} {item.search}</Badge>
                        ))}</div>}
                </ModalBody>
                <ModalFooter><Button onClick={() => this.addThisPreSearch()}>This one</Button></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.saveModal} toggle={this.flipSave.bind(this)}>
                <ModalBody>
                    <Input type="text" value={this.state.searchInputName} onChange={(e) => this.setState({ searchInputName: e.target.value })} />
                    <Label>Search Name</Label>
                </ModalBody>
                <ModalFooter><Button onClick={() => this.saveThisSearch()}>Save</Button></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.deleteModalOpen} toggle={this.flipDeleteModal.bind(this)}>
                <ModalBody>
                    <Input type="select" value={this.state.searchToDelete} onChange={(e) => this.setState({ searchToDelete: e.target.value })}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.userSearches.filter(remove => !searchPK.includes(remove.pk)).map(item => (
                            <option value={item.pk}>{item.name}</option>
                        ))}
                    </Input>
                </ModalBody>
                <ModalFooter>{this.state.deleteAskToConfirm && <Button color="danger" onClick={() => this.deleteSavedSearch()}>Confirm Delete</Button>}&ensp;&ensp;{this.state.searchToDelete != "DEFAULT" && <Button onClick={() => this.setState({ deleteAskToConfirm: true })}>This one</Button>}</ModalFooter>
            </Modal>
            <Row>
                <Col md={2}>
                    For students enrolled in <Input type="select" value={this.state.activeSemester} onChange={(e) => this.setState({ activeSemester: e.target.value })}>
                        <option disabled value="">Selct semester...</option>
                        {this.state.useSemester.map(item => (
                            <option>{item}</option>
                        ))}
                    </Input>
                </Col>
                <Col md={6} />
            </Row>
            <br />
            {this.state.currentFilters.map(item => (
                <span><Badge>{this.state.searchOptions.filter(remove => remove.typecode == item.type)[0].typedesc} {item.operand}
                    
                    "{item.string.replace("|/|", "\" and \"")}"&nbsp;<Button close onClick={(e) => { this.removeFilter(item.type, item.string) }}></Button></Badge>&ensp;</span>
            ))}
            <p />
            {this.state.loadedSearches.length > 0 &&
                <span><b>Including the results of these searches:</b>&nbsp;
                    {this.state.loadedSearches.map(item => (
                        <span><Badge>{this.state.userSearches.filter(remove => remove.pk == item.pk)[0].name}&nbsp;<Button close onClick={(e) => { this.removeSearch(item.pk) }}></Button></Badge></span>
                    ))}
                </span>}
            <p />
            <Row>
                <Col md={2}>
                    <FormGroup>
                        <Input type="select" name="searchType" id="searchType" value={this.state.searchType1} onChange={(e) => { this.setState({ searchType1: e.target.value }) }}>
                            {this.state.searchOptions.map(item => (
                                <option value={item.typecode}>{item.typedesc}</option>
                            ))}
                        </Input>
                        <Label>Search By</Label>
                    </FormGroup>
                </Col>
                <Col sm={2}><Input type="select" name="iscontains" id="iscontains" value={this.state.isContains} onChange={(e) => this.setState({ isContains: e.target.value })}>
                    <option>is</option>
                    <option>contains</option>
                    <option>is not</option>
                    <option>does not contain</option>
                    <option>starts with</option>
                    <option>ends with</option>
                    <option>between</option>
                </Input></Col>
                <Col md={2}>
                    <FormGroup>
                    <Form onSubmit={(e) => {
                        e.preventDefault()
                        this.setState({
                            currentFilters: [...this.state.currentFilters, { "type": this.state.searchType1, "operand": this.state.isContains, "string": this.state.searchString1 }],
                            searchString1: ""
                        }) } }><Input type="text" maxLength='100' name="searchString" id="searchString" value={this.state.searchString1} onChange={(e) => {
                            this.setState({ searchString1: e.target.value })
                        }} /></Form>
                    </FormGroup>
                </Col>
                {this.state.isContains == "between" && <Col>
                    and
                </Col>}
                {this.state.isContains == "between" && <Col md={2 }>
                    <Input type="text" maxLength='100' name="betweenString" id="betweenString" value={this.state.betweenString} onChange={(e) => this.setState({betweenString: e.target.value}) } />
                </Col>}
                <Col md={3}>
                    <Button onClick={(e) => {
                        let stringVal = this.state.searchString1
                        if (this.state.isContains == "between") {
                            stringVal = this.state.searchString1 + "|/|" + this.state.betweenString
                        }
                        this.setState({
                            currentFilters: [...this.state.currentFilters, { "type": this.state.searchType1, "operand": this.state.isContains, "string": stringVal }],
                            searchString1: "",
                            betweenString: ""
                        })

                    }}>Add</Button>
                </Col>
            <Col></Col>
            </Row>
            <div className="rightAlignCustom">
                <div className="inlineCustom"><Button onClick={() => this.flipModal()}>Load a search</Button></div><p />
                <div className="inlineCustom"><Button onClick={() => this.flipDeleteModal()}>Delete a search</Button></div>
            </div>
            <Button onClick={(e) => this.getStudents(e)}>Go</Button>
            
            <br />
            <br />
            <br />
            <br />
            <br />
            {this.state.loading && <div>Loading... <LoadingSpin size="30px" primaryColor="#132E53" /></div>}
            {this.state.studentData.length > 0 && <div>
                <div className="rightAlignCustom">
                    <Button onClick={() => this.flipSave()}>Save this search</Button>&nbsp;
                    <Button id="getStudents">Get This Student List...</Button>
                    <Popover placement="top" target="getStudents" isOpen={this.state.popOpen} toggle={() => this.setState({ popOpen: !this.state.popOpen })}>
                        <PopoverBody>
                            <Button onClick={() => this.sendMail(0) }>Send me this list</Button><p />
                            {this.state.studentData.length <= 50 && <Button onClick={(e) => {
                                e.preventDefault()
                                this.openEmail(userEmail)
                                }}>Send email to this list</Button>
                            }
                        </PopoverBody>
                    </Popover>
                </div><br /><br />
                {this.accordionDisplay()}</div>}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(StudentDirectory);
